export const CHILD_NPI_CSV_TEMPLATE_FILENAME = "child-facility-ccns.csv";

export function parsePastedCcns(text: string): string[] {
  const lines = text.split(/[\r\n,;\t]+/);
  const seen = new Set<string>();
  const valid: string[] = [];
  for (const line of lines) {
    const clean = line.replace(/\D/g, "").trim();
    if (clean.length >= 6 && clean.length <= 10 && !seen.has(clean)) {
      seen.add(clean);
      valid.push(clean);
    }
  }
  return valid;
}

export function formatCsvFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;
  const mb = bytes / (1024 * 1024);
  return `${mb.toFixed(1).replace(/\.0$/, "")} MB`;
}

export function isCsvUploadFile(file: File): boolean {
  const name = file.name.toLowerCase();
  if (name.endsWith(".csv")) return true;
  const type = (file.type || "").toLowerCase();
  return type === "text/csv" || type === "application/csv" || type === "text/comma-separated-values";
}
